import apiClient from "./apiClient";
import getSessionCode from "../utils/sessionCode";

// Send message to the chatbot and get response from the API
export const sendMessage = async (query, chat_history, language) => {
  let input = {
    "message": query,
    "session_id": getSessionCode(),
    "language": language || "pt",
  }
  const response = await apiClient.post("/user-request", input);
  return response.data;
};




export const _sendMessage = async (query, chat_history, language) => {
  const response = "test";
  return response;
};


// Receive greeting message from the chatbot
export const getGreetingMessage = async (language) => {
  const response = await apiClient.get("/greeting", { language });
  return response.data;
};